import { Controller } from "@hotwired/stimulus";
import { interpolate } from "../../utils/string_utils";
import { computeDueDate } from "../../sales_invoices/due_date";
import { formattedDate } from "../../utils/date_utils";
import { SALES_INVOICE_TYPES } from "../../utils/constants";

export default class extends Controller {
  static targets = ["container", "template", "paymentTermsInput", "customNumberOfDaysInput"];
  static values = { invoiceType: String };

  paymentTermsInputTargetConnected() {
    this.update();
  }

  update() {
    if (this.invoiceTypeValue !== SALES_INVOICE_TYPES.SALES_INVOICE) {
      return;
    }

    if (this.paymentTermsInputTarget.value === "custom") {
      this.containerTarget.innerHTML = "";
    } else {
      const dueDate = computeDueDate(new Date(), this._paymentTermsValue());
      this.containerTarget.innerHTML = interpolate(this.templateTarget, { dueDate: formattedDate(dueDate) });
    }
  }

  _paymentTermsValue() {
    if (this.paymentTermsInputTarget.value === "free") {
      return this.customNumberOfDaysInputTarget.value || "0";
    } else {
      return this.paymentTermsInputTarget.value;
    }
  }
}
